import { useMemo } from 'react';
import { useCan } from 'src/hooks/useCan';
import { ALL_MENUS } from 'src/pages/menu/constants/menuStructureProject'

export function useFilterSidebar(sidebarConfig) {
  const can = useCan();
  return useMemo(() => {
    return sidebarConfig.filter(sidebarItem => {
      const innerMenu = ALL_MENUS[sidebarItem.id];
      if (!innerMenu) { return can(sidebarItem.check); }
      return Object.entries(innerMenu)
        .map(([key, items]) => items)
        .flat()
        .some(subItem => can(subItem.check));
    })
  }, [sidebarConfig, can]);
}